import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_menu_item_navigation = _resolveComponent("menu-item-navigation")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_menu_item_navigation, { url: "/request-partner" }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode("Send a request", -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_menu_item_navigation, {
      "is-active": _ctx.isReviewRequestActive,
      url: "/review-request"
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode("Review completed requests", -1)
      ]))]),
      _: 1
    }, 8, ["is-active"]),
    _createVNode(_component_menu_item_navigation, { url: "/request-sent" }, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createTextVNode("Requests sent", -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_menu_item_navigation, { url: "/request-approved" }, {
      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
        _createTextVNode("Approved requests", -1)
      ]))]),
      _: 1
    })
  ]))
}